import { defineComponent as _defineComponent } from 'vue'
import Action, { ActionProps } from '@/components/atoms/action/Action.vue';
import Loading from '@/components/atoms/loading/Loading.vue';
import InputGroup, { InputGroupProps } from '../input/InputGroup.vue';

interface FormContainerProps {
    title: string;
    data: Record<string, InputGroupProps>;
    actions?: ActionProps[];
    isLoading: boolean;
    onBlur: (key: string, value: any) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FormContainer',
  props: {
    title: null,
    data: null,
    actions: null,
    isLoading: { type: Boolean },
    onBlur: null
  },
  setup(__props: any) {

const props = __props as {
    title: string;
    data: Record<string, InputGroupProps>;
    actions?: ActionProps[];
    isLoading: boolean;
    onBlur: (key: string, value: any) => void;
};



return { __sfc: true,props, Action, Loading, InputGroup }
}

})